import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueLayers from 'vuelayers';
import ELEMENT from 'element-ui';

import 'animate.css/animate.min.css';
import 'vuelayers/lib/style.css';

// import '@/assets/css/theme/index.css';
// import '@/assets/css/theme/dark.css';
// import '@/assets/css/theme/light.css';

import TitleComp from '@/components/title-comp';
import MyScrollbar from '@/components/scrollbar';

import App from './App.vue';

import router from '@/router/index';
import store from '@/store';
import { i18n } from '@/locale';
import { registryLangHook } from '@/locale/hooks';

import overAll from '@/mixins/overAll';

import directive from '@/directive';
import './permission';
import { syncTitle } from '@/utils/siteTitle';
import EnvUtils from './utils/EnvUtils';
import { normalizeWindowName } from './utils/utils';
import { registryMConfirm } from './components/mConfirm';
import VueECharts from '@/components/vue-echarts.vue';

Vue.use(overAll);
Vue.use(VueLayers);
Vue.use(ELEMENT, {
  i18n: (path, options) => {
    return i18n.t(path, options);
  }
});
Vue.use(directive);

Vue.component('v-chart', VueECharts);
Vue.component('title-comp', TitleComp);
Vue.component('scrollbar', MyScrollbar);
Vue.config.productionTip = false;
sync(store, router);

syncTitle();
// 标准化window.name
normalizeWindowName();

registryLangHook();

registryMConfirm(Vue);

if (EnvUtils.is('production', true)) {
  Vue.config.devtools = false;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});
